export default __webpack_public_path__ + "static/media/cosmos-5809271_1920.8766cc2e.png";